/**
 * A LINK TO ONE IDENTITY CASE — from the player's KYC tab to the check on Identity checks, where a
 * person decides it, or allows one more try after it.
 *
 * One place for the link's shape: the KYC tab writes it, and Identity checks reads the case it names
 * (`CASE_PARAM`) and opens it as its own Open would, with the reader's brand scope decided by the case
 * route. The link opens the Decided tab, which is where a decided check is listed.
 */
export const CASE_PARAM = 'case';

/**
 * WHETHER A VALUE FROM THE ADDRESS NAMES AN IDENTITY CHECK, before anything is asked for with it.
 *
 * A check's id is what the database writes (`gen_random_uuid()`): a uuid in its canonical form,
 * lower-case hex in groups of 8, 4, 4, 4 and 12. Only that is ever put into a request, so a crafted
 * link — a path that climbs out of the case, a slash, nothing at all — cannot steer a signed-in
 * reader's browser at another route.
 */
export function namesAnIdentityCheck(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value);
}

/** What a link that names no identity check is answered with. */
export const LINK_NAMES_NO_CHECK = 'That link does not name an identity check.';

export function identityCaseHref(recordId: string): string {
  return `/identity?tab=decided&${CASE_PARAM}=${encodeURIComponent(recordId)}`;
}
